import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsPaternFill from 'highcharts/modules/pattern-fill';
import { renderToString } from 'react-dom/server';
import {
  TooltipWrapper,
  TooltipHeader,
  TooltipRowTitle,
  TooltipRowValue,
  TooltipRow,
} from './PieChart.styles';

HighchartsPaternFill(Highcharts);

export interface IData {
  name: string;
  value: number;
  spend: string;
  isOther?: boolean;
  color?: any;
  y: number;
}

interface IProps {
  data: IData[];
  seriesId: string;
  colors: string[];
}

export const PieChart: React.FC<IProps> = ({ data, seriesId, colors }) => {
  const getOptions = () => {
    return {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        style: { fontFamily: 'Roboto' },
        width: 420,
        height: 420,
      },
      credits: { enabled: false },
      exporting: { enabled: false },
      title: { text: '' },
      colors,
      series: [
        {
          innerSize: 108,
          size: 360,
          data,
          id: seriesId,
        },
      ],
      plotOptions: {
        pie: {
          dataLabels: { enabled: false },
          borderWidth: 3,
        },
        series: {
          dataGrouping: {
            enabled: false,
          },
          animation: { duration: 400 },
          states: {
            inactive: { enabled: false },
            hover: {
              animation: { duration: 20 },
              halo: {
                size: 0,
              },
            },
          },
        },
      },
      tooltip: {
        useHTML: true,
        backgroundColor: 'white',
        borderWidth: 0,
        borderRadius: 2,
        outside: true,
        formatter: function () {
          // @ts-ignore
          const { point } = this as any;

          if (point.isOther) {
            return false;
          }

          return renderToString(
            <TooltipWrapper>
              <TooltipHeader>{point.name}</TooltipHeader>
              <TooltipRow>
                <TooltipRowTitle>Allocation</TooltipRowTitle>
                <TooltipRowValue>{point.value}%</TooltipRowValue>
              </TooltipRow>
              <TooltipRow>
                <TooltipRowTitle>Spend value </TooltipRowTitle>
                <TooltipRowValue>{point.spend}</TooltipRowValue>
              </TooltipRow>
            </TooltipWrapper>
          );
        },
      },
    };
  };

  return <HighchartsReact highcharts={Highcharts} options={getOptions()} />;
};
